import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import MainLayout from '../components/Layout/MainLayout.js';
import { updateMetaTags } from '../utils/metaTags.js';

const FeaturesPage = () => {
    useEffect(() => {
        updateMetaTags(
            'Funktioner - HåndværkerNet',
            'Se alle funktioner i HåndværkerNet. AI-genereret indhold, billedegalleri, nemt kontrolpanel og meget mere.',
            'https://haandvaerkernet.dk/images/logo.png'
        );
    }, []);

    const features = [
        {
            title: "AI-genereret indhold",
            description: "Få professionelt indhold automatisk genereret baseret på din virksomheds data og branche.",
            icon: (
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
            )
        },
        {
            title: "Brugervenligt kontrolpanel",
            description: "Administrer nemt din hjemmeside gennem vores intuitive dashboard, hvor du kan redigere indhold, uploade billeder og meget mere.",
            icon: (
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                </svg>
            )
        },
        {
            title: "Sidehåndtering",
            description: "Opret og organiser ubegrænset antal sider til din hjemmeside. Hver side kan have sit eget unikke indhold og layout.",
            icon: (
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9.5a2 2 0 00-2-2h-2" />
                </svg>
            )
        },
        {
            title: "Billedearkiv",
            description: "Upload og administrer billeder i dit personlige billedarkiv. Brug dem nemt på tværs af alle dine sider.",
            icon: (
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
            )
        },
        {
            title: "Kontaktoplysninger",
            description: "Hold dine kontaktoplysninger og åbningstider opdateret, så dine kunder altid kan finde dig.",
            icon: (
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
            )
        },
        {
            title: "Sociale medier integration",
            description: "Tilføj nemt links til dine sociale medier profiler og skab en sammenhængende online tilstedeværelse.",
            icon: (
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14" />
                </svg>
            )
        },
        {
            title: "Billedegalleri",
            description: "Vis dine projekter frem i et flot billedgalleri. Perfekt til at præsentere før- og efterbilleder af dine håndværksopgaver.",
            icon: (
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
                </svg>
            )
        },
        {
            title: "Professionelle farvetemaer",
            description: "Vælg mellem mange forskellige farvetemaer og tilpas din hjemmeside til dit brand. Fra klassisk blå til moderne grøn - du bestemmer udseendet.",
            icon: (
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01" />
                </svg>
            )
        },
        {
            title: "100% mobilvenlig",
            description: "Din hjemmeside ser perfekt ud på alle enheder - mobil, tablet og computer. Den tilpasser sig automatisk skærmstørrelsen for den bedste brugeroplevelse.",
            icon: (
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
                </svg>
            )
        },
        {
            title: "Ubegrænset sideantal",
            description: "Opret lige så mange sider du har brug for. Vis dine forskellige services, projekter eller specialer - der er ingen begrænsninger på antallet af sider.",
            icon: (
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
            )
        }
    ];

    return (
        <MainLayout>
            <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-12">
                    <h1 className="text-4xl font-bold font-montserrat text-gray-900 mb-4">
                        Alt hvad du behøver
                    </h1>
                    <p className="text-xl text-gray-600">
                        Få en professionel hjemmeside med alle de funktioner du har brug for
                    </p>
                </div>

                <div className="grid md:grid-cols-2 gap-8">
                    {features.map((feature, index) => (
                        <div key={index} className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow">
                            <div className="flex items-center mb-4">
                                <div className="bg-brand-light/20 p-3 rounded-lg">
                                    <div className="text-brand-dark">
                                        {feature.icon}
                                    </div>
                                </div>
                                <h3 className="ml-4 text-xl font-semibold font-montserrat text-gray-900">
                                    {feature.title}
                                </h3>
                            </div>
                            <p className="text-gray-600">
                                {feature.description}
                            </p>
                        </div>
                    ))}
                </div>

                {/* CTA Section */}
                <div className="mt-16 text-center">
                    <Link 
                        to="/onboarding"
                        className="inline-flex items-center justify-center px-6 py-3 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-brand-dark hover:bg-brand-dark/90 transition-colors duration-200"
                    >
                        Opret din hjemmeside
                    </Link>
                    <div className="mt-4 text-sm text-gray-600">
                        Eller læs mere om <Link to="/hvad-er-med-i-prisen" className="text-brand-dark underline">hvad der er med i prisen</Link> eller se vores <Link to="/blog" className="text-brand-dark underline">guides og blog</Link>.
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default FeaturesPage;